import { Grid as BaseGrid, styled } from '@mui/material'

export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  width: 100%;
`

export const ImgOnboarding01 = styled('img')`
  height: 170px;
  width: 200px;
`

export const Root = styled('div')`
  width: 100%;
`

export const Row = styled('div')`
  text-align: center;
  width: 100%;
`
